import {EnumInterpretace} from '../api';

/**
 * Čitelný název interpretace atributu.
 */
export const getEnumInterpretaceReadable = (interpretace: string | EnumInterpretace): string => {
    switch (interpretace) {
        case EnumInterpretace.FORMATOVANYTEXT:
            return 'Formátovaný text';
        case EnumInterpretace.ODKAZ:
            return 'Odkaz';
        case EnumInterpretace.EMAIL:
            return 'E-mail';
        case EnumInterpretace.TELEFON:
            return 'Telefon';
        case EnumInterpretace.CISELNIK:
            return 'Jednohodnotový číselník';
        case EnumInterpretace.MULTI_CISELNIK:
            return 'Vícehodnotový číselník';
        default:
            return `_${interpretace}`;
    }
};

/**
 * Položky výběru pro atribut typu Číselník (ENUM) – jedno- vs. vícehodnotový číselník.
 */
export const getCiselnikInterpretaceItems = (): {id: EnumInterpretace; name: string}[] => [
    {id: EnumInterpretace.CISELNIK, name: 'Jednohodnotový'},
    {id: EnumInterpretace.MULTI_CISELNIK, name: 'Vícehodnotový'},
];

/**
 * Položky výběru interpretace pro atribut typu Jednořádkový text (STRING).
 * Prázdná hodnota (placeholder „Prostý text") = null.
 */
export const getStringInterpretaceItems = (): {id: EnumInterpretace; name: string}[] =>
    [EnumInterpretace.ODKAZ, EnumInterpretace.EMAIL, EnumInterpretace.TELEFON].map(i => ({id: i, name: getEnumInterpretaceReadable(i)}));

/**
 * Položky výběru interpretace pro atribut typu Dlouhý text (TEXT).
 * Prázdná hodnota (placeholder „Prostý text") = null.
 */
export const getTextInterpretaceItems = (): {id: EnumInterpretace; name: string}[] => [
    {id: EnumInterpretace.FORMATOVANYTEXT, name: getEnumInterpretaceReadable(EnumInterpretace.FORMATOVANYTEXT)},
];
